import { atom } from '@reatom/framework'

export const notificationCenterUpdatesAtom = atom<{
  walletTracker: number
  premium: number
  notifications: number
  support: number
}>(
  {
    walletTracker: 0,
    premium: 0,
    notifications: 0,
    support: 0,
  },
  'notificationCenterUpdatesAtom',
)

export const notificationCenterScreenAtom = atom<'view' | 'edit'>(
  'view',
  'notificationCenterScreenAtom',
)

export const notificationCenterUpdatesCountAtom = atom<number>(
  0,
  'notificationCenterUpdatesCountAtom',
)
